const empty = () =>
    import ( /* webpackChunkName: "empty" */ '../views/Empty.vue');

const QuestionCheckPointManage = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionCheckPointManage.vue');
const QuestionCheckPointEdit = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionCheckPointEdit.vue');
const QuestionBankManage = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionBankManage.vue');
const QuestionBankTopic = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionBankTopic.vue');
const QuestionBankTopicEdit = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionBankTopicEdit.vue');
const QuestionBankTopicImport = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionBankTopicImport.vue');
const QuestionBankCatagory = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionBankCatagory.vue');
const QuestionTopicError = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionTopicError.vue');
const QuestionTopicErrorEdit = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionTopicErrorEdit.vue');
const QuestionPaperManage = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionPaperManage.vue');
const QuestionPaperCatagory = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionPaperCatagory.vue');
const QuestionPaperPackageManage = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionPaperPackageManage.vue');
const QuestionPaperPackageChoose = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionPaperPackageChoose.vue');
const QuestionPaperDetail = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionPaperDetail.vue');
const QuestionPaperPackageDetail = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionPaperPackageDetail.vue');
const QuestionExamManage = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionExamManage.vue');
const QuestionExamAdd = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionExamAdd.vue');
const QuestionPaperEdit = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionPaperEdit.vue');
const QuestionExerciseManage = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionExerciseManage.vue');
const QuestionExerciseAdd = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionExerciseAdd.vue');
const QuestionExerciseChapter = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionExerciseChapter.vue');
const QuestionExerciseChapterPeriod = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionExerciseChapterPeriod.vue');
const QuestionCheckinManage = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionCheckinManage.vue');
const QuestionCheckinAdd = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionCheckinAdd.vue');
const QuestionCheckincCalendar = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionCheckincCalendar.vue');
const QuestionDailyAdd = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionDailyAdd.vue');
const QuestionJoiner = () =>
    import ( /* webpackChunkName: "question" */ '../views/question/QuestionJoiner.vue');

export default [{
    path: 'question',
    name: 'Question',
    component: empty,
    children: [{
            path: 'point',
            name: 'QuestionCheckPointManage',
            component: QuestionCheckPointManage,
            meta: {
                title: '考点管理',
                keepAlive: true,
                root: true
            },
        },
        {
            path: 'point/edit',
            name: 'QuestionCheckPointEdit',
            component: QuestionCheckPointEdit,
            meta: {
                title: '新增/编辑考点'
            },
        },
        {
            path: 'bank',
            name: 'QuestionBank',
            component: empty,
            children: [{
                path: 'manage',
                name: 'QuestionBankManage',
                component: QuestionBankManage,
                meta: {
                    title: '题库管理',
                    root: true
                },
            }, {
                path: 'topic',
                name: 'QuestionBankTopic',
                component: QuestionBankTopic,
                meta: {
                    title: '试题管理',
                    keepAlive: true
                },
            }, {
                path: 'topic/edit',
                name: 'QuestionBankTopicEdit',
                component: QuestionBankTopicEdit,
                meta: {
                    title: '新增/编辑试题'
                },
            }, {
                path: 'topic/import',
                name: 'QuestionBankTopicImport',
                component: QuestionBankTopicImport,
                meta: {
                    title: '导入试题'
                },
            }, {
                path: 'catagory',
                name: 'QuestionBankCatagory',
                component: QuestionBankCatagory,
                meta: {
                    title: '题库分类',
                    root: true
                },
            }, {
                path: 'error',
                name: 'QuestionTopicError',
                component: QuestionTopicError,
                meta: {
                    title: '题目报错',
                    keepAlive: true,
                    root: true
                },
            }, {
                path: 'error/edit',
                name: 'QuestionTopicErrorEdit',
                component: QuestionTopicErrorEdit,
                meta: {
                    title: '修改题目报错'
                },
            }]
        },
        {
            path: 'paper',
            name: 'QuestionPaper',
            component: empty,
            children: [{
                path: 'manage',
                name: 'QuestionPaperManage',
                component: QuestionPaperManage,
                meta: {
                    title: '试卷管理',
                    root: true
                },
            }, {
                path: 'catagory',
                name: 'QuestionPaperCatagory',
                component: QuestionPaperCatagory,
                meta: {
                    title: '试卷分类',
                    root: true
                },
            }, {
                path: 'add',
                name: 'QuestionPaperAdd',
                component: QuestionPaperEdit,
                meta: {
                    title: '新增试卷'
                }
            }, {
                path: 'edit',
                name: 'QuestionPaperEdit',
                component: QuestionPaperEdit,
                meta: {
                    title: '编辑试卷'
                }
            }, {
                path: 'detail',
                name: 'QuestionPaperDetail',
                component: QuestionPaperDetail,
                meta: {
                    title: '试卷详情'
                }
            }]
        },
        {
            path: 'paper-package',
            name: 'QuestionPaperPackageManage',
            component: QuestionPaperPackageManage,
            meta: {
                title: '套卷管理',
                root: true
            },
        },
        {
            path: 'paper-package-choose',
            name: 'QuestionPaperPackageChoose',
            component: QuestionPaperPackageChoose,
            meta: {
                title: '选择试卷'
            },
        },
        {
            path: 'paper-package-choose-detail',
            name: 'QuestionPaperChooseDetail',
            component: QuestionPaperDetail,
            meta: {
                title: '试卷详情'
            },
        },
        {
            path: 'paper-package-detail',
            name: 'QuestionPaperPackageDetail',
            component: QuestionPaperPackageDetail,
            meta: {
                title: '套卷练习详情'
            },
        },
        {
            path: 'student-paper-detail',
            name: 'StudentPaperDetail',
            component: QuestionPaperDetail,
            meta: {
                title: '查看'
            },
        },
        {
            path: 'exam',
            name: 'QuestionExamManage',
            component: QuestionExamManage,
            meta: {
                title: '模拟考试',
                root: true
            },
        },
        {
            path: 'exam-add',
            name: 'QuestionExamAdd',
            component: QuestionExamAdd,
            meta: {
                title: '新增考试'
            },
        },
        {
            path: 'exam-detail',
            name: 'ExamDetail',
            component: QuestionPaperPackageDetail,
            meta: {
                title: '考试详情'
            },
        },
        {
            path: 'exam-paper-detail',
            name: 'ExamPaperDetail',
            component: QuestionPaperDetail,
            meta: {
                title: '查看'
            },
        },
        {
            path: 'exercise',
            name: 'QuestionExercise',
            component: empty,
            children: [{
                    path: '',
                    name: 'QuestionExercise',
                    component: QuestionExerciseManage,
                    meta: {
                        title: '章节练习',
                        keepAlive: true,
                        root: true,
                    },
                },
              {
                  path: 'exercise-add',
                  name: 'QuestionExerciseAdd',
                  component: QuestionExerciseAdd,
                  meta: {
                      title: '新增练习'
                  },
              },
              {
                  path: 'chapter',
                  name: 'QuestionExerciseChapter',
                  component: QuestionExerciseChapter,
                  meta: {
                      title: '章节列表'
                  },
              },
              {
                  path: 'chapter/period/create',
                  name: 'QuestionExerciseChapterPeriodCreate',
                  component: QuestionExerciseChapterPeriod,
                  meta: {
                      title: '新增节'
                  },
              },
              {
                  path: 'chapter/period/edit',
                  name: 'QuestionExerciseChapterPeriodEdit',
                  component: QuestionExerciseChapterPeriod,
                  meta: {
                      title: '编辑节'
                  },
              }
            ]
        },
        {
            path: 'checkin',
            name: 'QuestionCheckin',
            component: empty,
            children: [
              {
                  path: '',
                  name: 'QuestionCheckinManage',
                  component: QuestionCheckinManage,
                  meta: {
                      title: '打卡活动',
                      keepAlive: true,
                      root: true
                  },
              },
              {
                  path: 'add',
                  name: 'QuestionCheckinAdd',
                  component: QuestionCheckinAdd,
                  meta: {
                      title: '新增打卡'
                  },
              },
              {
                  path: 'calendar',
                  name: 'QuestionCheckincCalendar',
                  component: QuestionCheckincCalendar,
                  meta: {
                      title: '添加打卡'
                  },
              },
              {
                  path: 'daily-add',
                  name: 'QuestionDailyAdd',
                  component: QuestionDailyAdd,
                  meta: {
                      title: '编辑习题'
                  },
              },
              {
                  path: 'joiners',
                  name: 'QuestionJoiner',
                  component: QuestionJoiner,
                  meta: {
                      title: '参与人员'
                  },
              }
            ],
        },
    ]
}]
